// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-tool {
  --bg-color: #cdd1e0;
  --front-color: #388ae5;
  --border-color: #e8e8eb;
}

  .image-tool__image {
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 10px;
    display: inline-block;
  }

  .image-tool__image .lightbox {
      display: block;
    }

  .image-tool__image-picture {
      display: inline-block;
      max-width: 100%;
      vertical-align: bottom;
    }

  .image-tool__image-preloader {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-size: cover;
      margin: auto;
      position: relative;
      background-color: var(--bg-color);
      background-position: center center;
    }

  .image-tool__image-preloader::after {
        content: "";
        position: absolute;
        z-index: 3;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 2px solid var(--bg-color);
        border-top-color: var(--front-color);
        left: 50%;
        top: 50%;
        margin-top: -30px;
        margin-left: -30px;
        animation: image-preloader-spin 2s infinite linear;
        box-sizing: border-box;
      }

  .image-tool__caption[contentEditable="true"][data-placeholder]::before {
      position: absolute !important;
      content: attr(data-placeholder);
      color: #707684;
      font-weight: normal;
      display: none;
    }

  .image-tool__caption[contentEditable="true"][data-placeholder]:empty::before {
        display: block;
      }

  .image-tool__caption[contentEditable="true"][data-placeholder]:empty:focus::before {
        display: none;
      }

  .image-tool--empty .image-tool__image {
      display: none;
    }

  .image-tool--empty .image-tool__caption, .image-tool--loading .image-tool__caption {
      display: none;
    }

  .image-tool--filled .cdx-button {
      display: none;
    }

  .image-tool--filled .image-tool__image {
      position: relative;
      text-align: left;
    }

  @media only screen and (min-width:768px){

  .image-tool--filled .image-tool__image {
        width: 100%
    }
      }

  .image-tool--filled .image-tool__image-preloader {
        display: none;
      }

  .image-tool--loading .image-tool__image {
      min-height: 200px;
      display: flex;
      border: 1px solid var(--border-color);
      background-color: #fff;
    }

  .image-tool--loading .image-tool__image-picture {
        display: none;
      }

  .image-tool--loading .cdx-button {
      display: none;
    }

  .image-tool--left {
    text-align: left;
  }

  .image-tool--center {
    text-align: center;
  }

  .image-tool--right {
    text-align: right;
  }

  @media only screen and (min-width:768px){

  .image-tool--large .image-tool__image {
        width: 100%
    }
      }

  @media only screen and (min-width:768px) {

  .image-tool--middle .image-tool__image {
        width: 75%
    }
      }

  @media only screen and (min-width:768px) {

  .image-tool--small .image-tool__image {
        width: 50%
    }
      }

  /**
 * Tunes
 * ----------------
 */

  .image-tool--withBorder .image-tool__image {
      border: 1px solid var(--border-color);
    }

  .image-tool--withBackground .image-tool__image {
      padding: 15px;
      background: var(--bg-color);
    }

  .image-tool--withBackground .image-tool__image-picture {
        max-width: 60%;
        margin: 0 auto;
      }

  .image-tool--stretched .image-tool__image-picture {
        width: 100%;
      }
.ce-settings__width__input {
  border: 1px solid rgba(201, 201, 204, 0.48);
  -webkit-box-shadow: inset 0 1px 2px 0 rgba(35, 44, 72, 0.06);
  box-shadow: inset 0 1px 2px 0 rgba(35, 44, 72, 0.06);
  border-radius: 5px;
  padding: 5px 8px;
  height:30px;
  outline: none;
  flex-basis: 120px;
  max-width: 120px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.ce-settings__width {
  display: flex;
  width: 120px;
  justify-content: center;
}

.ce-settings__width .ce-settings__width__save {
    display: inline-block;
    height:25px;
    background-color: #34c38f;
    color: #fff;
    border: none;
    text-align: center;
    text-decoration: none;
    font-size: 12px;
    margin-right: 10px;
    border-radius: 5px;
    cursor: pointer;
  }

.ce-settings__width .ce-settings__width__reset {
    display: inline-block;
    height:25px;
    background-color: #ccc;
    color: #333;
    border: none;
    text-align: center;
    text-decoration: none;
    font-size: 12px;
    border-radius: 5px;
    cursor: pointer;
  }




@keyframes image-preloader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./mock/src/js/Libs/editorjs/image/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AAsLzB;;EApLE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EAuCvB;;EArCE;MACE,cAAc;IAChB;;EAEA;MACE,qBAAqB;MACrB,eAAe;MACf,sBAAsB;IACxB;;EAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,sBAAsB;MACtB,YAAY;MACZ,kBAAkB;MAClB,iCAAiC;MACjC,kCAAkC;IAkBpC;;EAhBE;QACE,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iCAAiC;QACjC,oCAAoC;QACpC,SAAS;QACT,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;QAClB,kDAAkD;QAClD,sBAAsB;MACxB;;EAKF;MACE,6BAA6B;MAC7B,+BAA+B;MAC/B,cAAc;MACd,mBAAmB;MACnB,aAAa;IACf;;EAGE;QACE,cAAc;MAChB;;EAEA;QACE,aAAa;MACf;;EAKF;MACE,aAAa;IACf;;EAKA;MACE,aAAa;IACf;;EAIA;MACE,aAAa;IACf;;EAEA;MACE,kBAAkB;MAClB,gBAAgB;IAQlB;;EAPE;;EAHF;QAII;IAMJ;MALE;;EAEA;QACE,aAAa;MACf;;EAKF;MACE,iBAAiB;MACjB,aAAa;MACb,qCAAqC;MACrC,sBAAsB;IAKxB;;EAHE;QACE,aAAa;MACf;;EAGF;MACE,aAAa;IACf;;EAGF;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAII;;EADF;QAEI;IAEJ;MADE;;EAMA;;EADF;QAEI;IAEJ;MADE;;EAMA;;EADF;QAEI;IAEJ;MADE;;EAKN;;;EAGE;;EAGE;MACE,qCAAqC;IACvC;;EAIA;MACE,aAAa;MACb,2BAA2B;IAM7B;;EAJE;QACE,cAAc;QACd,cAAc;MAChB;;EAMA;QACE,WAAW;MACb;AAIN;EACE,2CAA2C;EAC3C,4DAA4D;EAC5D,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AA0BzB;;AAzBE;IACE,qBAAqB;IACrB,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;AACA;IACE,qBAAqB;IACrB,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;;;;AAMF;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".image-tool {\n  --bg-color: #cdd1e0;\n  --front-color: #388ae5;\n  --border-color: #e8e8eb;\n\n  &__image {\n    border-radius: 3px;\n    overflow: hidden;\n    margin-bottom: 10px;\n    display: inline-block;\n\n    & .lightbox {\n      display: block;\n    }\n\n    &-picture {\n      display: inline-block;\n      max-width: 100%;\n      vertical-align: bottom;\n    }\n\n    &-preloader {\n      width: 50px;\n      height: 50px;\n      border-radius: 50%;\n      background-size: cover;\n      margin: auto;\n      position: relative;\n      background-color: var(--bg-color);\n      background-position: center center;\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        z-index: 3;\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n        border: 2px solid var(--bg-color);\n        border-top-color: var(--front-color);\n        left: 50%;\n        top: 50%;\n        margin-top: -30px;\n        margin-left: -30px;\n        animation: image-preloader-spin 2s infinite linear;\n        box-sizing: border-box;\n      }\n    }\n  }\n\n  &__caption {\n    &[contentEditable=\"true\"][data-placeholder]::before {\n      position: absolute !important;\n      content: attr(data-placeholder);\n      color: #707684;\n      font-weight: normal;\n      display: none;\n    }\n\n    &[contentEditable=\"true\"][data-placeholder]:empty {\n      &::before {\n        display: block;\n      }\n\n      &:focus::before {\n        display: none;\n      }\n    }\n  }\n\n  &--empty {\n    ^&__image {\n      display: none;\n    }\n  }\n\n  &--empty,\n  &--loading {\n    ^&__caption {\n      display: none;\n    }\n  }\n\n  &--filled {\n    .cdx-button {\n      display: none;\n    }\n\n    ^&__image {\n      position: relative;\n      text-align: left;\n      @media only screen and (min-width:768px){\n        width: 100%;\n      }\n\n      &-preloader {\n        display: none;\n      }\n    }\n  }\n\n  &--loading {\n    ^&__image {\n      min-height: 200px;\n      display: flex;\n      border: 1px solid var(--border-color);\n      background-color: #fff;\n\n      &-picture {\n        display: none;\n      }\n    }\n\n    .cdx-button {\n      display: none;\n    }\n  }\n\n  &--left {\n    text-align: left;\n  }\n\n  &--center {\n    text-align: center;\n  }\n\n  &--right {\n    text-align: right;\n  }\n\n  &--large {\n    ^&__image {\n      @media only screen and (min-width:768px){\n        width: 100%;\n      }\n    }\n  }\n\n  &--middle {\n    ^&__image {\n      @media only screen and (min-width:768px) {\n        width: 75%;\n      }\n    }\n  }\n\n  &--small {\n    ^&__image {\n      @media only screen and (min-width:768px) {\n        width: 50%;\n      }\n    }\n  }\n\n\n/**\n * Tunes\n * ----------------\n */\n\n  &--withBorder {\n    ^&__image {\n      border: 1px solid var(--border-color);\n    }\n  }\n\n  &--withBackground {\n    ^&__image {\n      padding: 15px;\n      background: var(--bg-color);\n\n      &-picture {\n        max-width: 60%;\n        margin: 0 auto;\n      }\n    }\n  }\n\n  &--stretched {\n    ^&__image {\n      &-picture {\n        width: 100%;\n      }\n    }\n  }\n}\n.ce-settings__width__input {\n  border: 1px solid rgba(201, 201, 204, 0.48);\n  -webkit-box-shadow: inset 0 1px 2px 0 rgba(35, 44, 72, 0.06);\n  box-shadow: inset 0 1px 2px 0 rgba(35, 44, 72, 0.06);\n  border-radius: 5px;\n  padding: 5px 8px;\n  height:30px;\n  outline: none;\n  flex-basis: 120px;\n  max-width: 120px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  margin-bottom: 10px;\n}\n\n.ce-settings__width {\n  display: flex;\n  width: 120px;\n  justify-content: center;\n  .ce-settings__width__save {\n    display: inline-block;\n    height:25px;\n    background-color: #34c38f;\n    color: #fff;\n    border: none;\n    text-align: center;\n    text-decoration: none;\n    font-size: 12px;\n    margin-right: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  .ce-settings__width__reset {\n    display: inline-block;\n    height:25px;\n    background-color: #ccc;\n    color: #333;\n    border: none;\n    text-align: center;\n    text-decoration: none;\n    font-size: 12px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n}\n\n\n\n\n@keyframes image-preloader-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
